<template>
    <div :class="[{'px-4': $vuetify.breakpoint.smAndDown}]">
        <p>für die Saison {{saisonText}} sind keine Daten vorhanden</p>
        <v-btn v-if="user.permissions.ergebnisdienst" color="primary" @click="ligaCreate()">
            Saison {{saisonText}} anlegen
        </v-btn>
    </div>
</template>

<script>
    export default {
        name: "liga-no-season",
        props: ['sportJahr'],
        computed: {
            saisonText(){ return this.sportJahr.replace('_', '/') },
            user(){ return this.$store.state.user; },
        },
        methods: {
            ligaCreate(){
                this.$emit('ligaAction', 'editSaison');
            }
        },
    }
</script>

<style scoped>

</style>